import React, { Component } from "react";
import "./current.css";
import HoldingsScreen from "../assets/icon/Holdings-screen@2x.png";

class Current extends Component {
  state = {};
  render() {
    return (
      <React.Fragment>
        <div className="container">
          <div className="row">
            <div className="col-12 title">
              <h1 className="Your-current-holding"> Your current holdings</h1>
            </div>
          </div>
        </div>
        <div className="container-fluid current">
          <div className="row tableRow">
            <div className="col-12 table">
              <img src={HoldingsScreen} alt="" className="img-fluid" />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Current;
